import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { getSpreadText } from '../../../utils/spreadTextUtils';

export default function SpreadControls({ 
  currentSpread, 
  totalPages, 
  onPreviousSpread, 
  onNextSpread
}) {
  const maxSpreads = Math.ceil(totalPages / 2);
  const displayText = getSpreadText(currentSpread, totalPages);

  return (
    <div className="flex items-center gap-4">
      <button
        onClick={onPreviousSpread}
        disabled={currentSpread === 0}
        className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50"
      >
        <ChevronLeftIcon className="h-5 w-5 text-gray-500" />
      </button>
      <span className="text-sm text-gray-600">
        {displayText}
      </span>
      <button
        onClick={onNextSpread}
        disabled={currentSpread === maxSpreads}
        className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50"
      >
        <ChevronRightIcon className="h-5 w-5 text-gray-500" />
      </button>
    </div>
  );
}